import {useState, useRef, useEffect} from 'react';
// ** Reactstrap Imports
import { Row, Col, Card, CardBody, Form, Label, Input, Button } from 'reactstrap';
import { useNavigate, useParams } from 'react-router-dom';

import axios from 'axios';
import { toast } from 'react-toastify';
import useAuth from '../../hooks/useAuth';

const EditTestimonial = () => {
  const { auth } = useAuth();

  const navigate = useNavigate();
  const {id} = useParams();

  const [testimonialInfo, setTestimonialInfo] = useState({})


  const fileInputRef = useRef();
  const [authorImg, setAuthorImg] = useState(null)
  const [isEditMode, setIsEditMode] = useState(false);
  const [mykey, setMyKey] = useState('')


  const convertToBase64 = file => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      if (!file) {
        alert("please select an image")
      }else {
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
          resolve(fileReader.result)
        }
      }
      fileReader.onerror = error => {
          reject(error)
      }
    })
  }


  const addImage = async (e) => {
    setIsEditMode(true);
    const file = e.target.files[0];
    const base64Img = await convertToBase64(file);
    fileInputRef.current.value = base64Img;
    setAuthorImg(e.target.files[0]);
  };

  const getData = async () => {
          try {
            await axios.get(`${process.env.REACT_APP_API_BASE_URL}/testimonials/find-testimonial/${id}`, {
                headers: {
                    'Authorization': 'Bearer ' + auth.accessToken
                }
            }).then(res => {
              setTestimonialInfo(res.data);
              setAuthorImg(res.data.authorImg);
            })
        } catch (error) {
          error.response.data.message ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000
            }) :  toast.error(error.response.data.error, {
              className: "error-toast",
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 3000
          })
        }
      }
    

    useEffect(() => {
      getData();
    },[id])

    // ** States
   let initialState = testimonialInfo;


    const handleChange = (event) => {
        const { value, name } = event.target
        setTestimonialInfo(prevValue => {
            return({
                ...prevValue,
                [name]: value
            })
        });
    }


    const handleUpdateClick = async (event, id) => {
        event.preventDefault();

        let testimonialTitle = testimonialInfo.testimonialTitle;
        let testimonialDesc = testimonialInfo.testimonialDesc;
        let authorName = testimonialInfo.authorName;

        const formData = new FormData();
        formData.append("testimonialTitle", testimonialTitle);
        formData.append("testimonialDesc", testimonialDesc);
        formData.append("authorName", authorName);
        formData.append("authorImg", authorImg);


        try {
            const res = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/testimonials/update-testimonial/${id}`, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'Bearer ' + auth.accessToken
                }
            })
            toast.success(res.data.message, {
                className: "success-toast",
                autoClose: 3000,
                position: toast.POSITION.BOTTOM_RIGHT
            })
            navigate('/testimonials/view')
        } catch (error) {
          error.response.data.message ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000
            }) :  toast.error(error.response.data.error, {
              className: "error-toast",
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 3000
          })
            
        }
    }


    const handleReset = async (event) => {
      event.preventDefault();
      navigate('/testimonials/view')
    }
 
  return (
    <div className="container">
      <Row sm="12">
        <h5 className="sec-header">Edit testimonial</h5>
      </Row> 
      <Row sm='12'>
        <Card>
            <CardBody>
            
          <Col sm='12' className='mb-2'>
          <Form>
            
            <div className='mb-1'>
              <Label className='form-label' for='title'>
                Testimonial Title <span className='text-danger'>*</span>
              </Label>
              <Input
                id='title'
                type='text'
                className='me-1'
                name='testimonialTitle'
                minLength={20}
                maxLength={90}
                required={true}
                value={testimonialInfo.testimonialTitle}
                onChange={handleChange}
                
              />

            </div>

            <div className='mb-1'>
              <Label className='form-label' for='title'>
                Testimonial Description <span className='text-danger'>*</span>
              </Label>
              <Input
                id='testimonialDesc'
                type='textarea'
                className='me-1'
                name='testimonialDesc'
                minLength={60}
                maxLength={150}
                required={true}
                value={testimonialInfo.testimonialDesc}
                onChange={handleChange}
              />
            </div>

            <div className="mb-1">
                  <Label className="form-label" for="title">
                    Author Name <span className="text-danger">*</span>
                  </Label>
                  <Input
                    id="authorName"
                    type="text"
                    className="me-1"
                    name="authorName"
                    required={true}
                    value={testimonialInfo.authorName}
                    onChange={handleChange}
                  />
            </div>


            <div className='mb-1'>
              <Label className='form-label' for='title'>
                Image <span className='text-danger'>(max size: 100KB, width: 400 x height 400)</span>
              </Label>
              <Input
                id='authorImg'
                type='file'
                className='me-1'
                name='authorImg'
                accept='image/png, image/jpeg, image/jpg'
                required={true}
                key={mykey || ''}
                ref={fileInputRef} onChange={addImage}
              />
            </div>
           
            {isEditMode  ?  <div className='mb-3 mt-3'>
             
              <div>
              <img
                 style={{width: 180}}
                 src={fileInputRef && fileInputRef.current &&  fileInputRef.current.value || ''} />
              </div>
            </div> : <div className='mb-3 mt-3'>
              <div>   
              {
               testimonialInfo.authorImg &&  <img style={{width: 250}} src={`${process.env.REACT_APP_API_IMAGE_URI.substring(0, process.env.REACT_APP_API_IMAGE_URI.indexOf("/api"))
               + testimonialInfo.authorImg.substring(testimonialInfo.authorImg.indexOf("/uploads"))}`} alt={testimonialInfo.authorName}></img>
              }            
             
              </div>
           </div>}

            <Row className='pt-2'>
              <Col>
              <div className='mb-1'>
                <Button
                  block
                  color="success"
                  type='submit'
                  onClick={event => handleUpdateClick(event, id)}
                >
                  Update
                </Button>
              </div>
          
              </Col>
              <Col>
                <div className='mb-1'>
                  <Button
                    block
                    color="warning"
                    onClick={event => handleReset(event)}
                  >
                    Cancel & Go to testimonial list
                  </Button>
                </div>         
              </Col>
            </Row>
          </Form>
            
          </Col>
          </CardBody>
        </Card>
          
      </Row>
    </div>
  );
};

export default EditTestimonial;
